import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { VoiceDictation } from "@/components/voice-dictation";
import { EnvBadge } from "@/components/env-badge";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="min-h-screen bg-surface-base">
      <EnvBadge />
      <Outlet />
      <Toaster position="top-center" richColors closeButton />
      <VoiceDictation />
    </div>
  );
}
